import { forwardRef, ReactNode, type ComponentProps } from 'react';
import { PhoneInput } from '../../atoms/phone-input.component';
import { FieldLayoutWithAction } from '../../layouts/field-layout-with-action';
import type { BasicFormFieldProps, ExtraFieldProps, FieldActionProps } from '../../layouts/types';

type Props = BasicFormFieldProps<'phone'> &
  ExtraFieldProps &
  FieldActionProps & {
    autoFocus?: boolean;
    endAdornment?: ReactNode;
  };

export const PhoneField = forwardRef<HTMLDivElement, Props>((props, ref) => (
  <FieldLayoutWithAction
    {...props}
    //TODO: this might be able to be improved. But this type cast just makes sure the field prop is any of the correct field types
    field={PhoneInput as ComponentProps<typeof FieldLayoutWithAction>['field']}
    ref={ref}
  />
));

PhoneField.displayName = 'PhoneField';
